import { call, all, put, takeLatest } from "redux-saga/effects";

import { userTypes as types } from "../actions";
import { AxiosResponse } from "axios";
import { logoutUserService } from "../../../services/learner/user";
import { EntityIdPayload } from "../../../utils";
import StorageService from "../../../services/storageService";

export default function* learnerUserSagas() {
  yield all([takeLatest(types.LOGOUT, handleLogout)]);
}

function* handleLogout(action: any) {
  const { data }: AxiosResponse = yield call(logoutUserService);
  StorageService.clearStorage();
  yield put({
    type: "LOGOUT",
    payload: null,
  });
  action.payload.navigate("/login");
}
